import React from 'react';
import { Modal } from 'react-bootstrap';
import {
  UIDSLComponent,
  UIDSLComponentProps,
  UIDSLComponentType,
} from '@dreamai/types';
import { UIUpdate } from './UIComponentRenderer';

interface CanvasAssetComponent {
  id: string;
  component_type: string;
  props: Record<string, any>;
}

interface CanvasAsset {
  id: string;
  thread_id: string;
  created_at: string;
  title?: string;
  components: CanvasAssetComponent[];
  pinned?: boolean;
}

interface AppLayoutAssetModalProps {
  show: boolean;
  asset: CanvasAsset | null;
  threadId: string | null;
  onClose: () => void;
  updateThreadViewVisualDescription?: (
    visualDescription: string,
  ) => Promise<void>;
  container?: HTMLElement | null;
}

const AppLayoutAssetModal: React.FC<AppLayoutAssetModalProps> = ({
  show,
  asset,
  threadId,
  onClose,
  updateThreadViewVisualDescription,
  container,
}) => {
  if (!asset) return null;

  const isConfirmationModal = asset.components.some(
    (c) => c.component_type === 'ConfirmationCarousel',
  );

  return (
    <Modal
      show={show}
      onHide={onClose}
      size='lg'
      centered
      backdrop='static'
      className={`app-layout-asset-modal${isConfirmationModal ? ' confirmation-modal' : ''}`}
      contentClassName='app-layout-asset-modal-content'
      container={container}
      enforceFocus={false}
      autoFocus={false}
    >
      {!isConfirmationModal && (
        <Modal.Header closeButton>
          <Modal.Title>{asset.title || 'Canvas Asset'}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        {asset.components.map(
          (component: CanvasAssetComponent, index: number) => {
            const isConfirmationCarousel =
              component.component_type === 'ConfirmationCarousel';

            const uiComponent: UIDSLComponent = {
              type: component.component_type as UIDSLComponentType,
              id: component.id,
              props: {
                ...component.props,
                componentId: component.id,
                ...(isConfirmationCarousel && { inModal: true, onClose }),
              } as unknown as UIDSLComponentProps,
            };

            return (
              <UIUpdate
                component={uiComponent}
                viewId={asset.id}
                threadId={threadId}
                section='canvas-assets'
                onUserInput={() => {}}
                updateThreadViewVisualDescription={
                  updateThreadViewVisualDescription
                }
                key={`modal-${asset.id}-component-${index}`}
              />
            );
          },
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AppLayoutAssetModal;
